module.exports = __webpack_public_path__ + "img/badge.1591b8bf.png";